export default "/images/icon-close.svg?faa837b0e6babe66507a20ffa2757784";